import "./style.scss";

export const DivSkeleton = () => {
	return <div className={`skeleton div-skeleton`}></div>;
};

export default DivSkeleton;
